module.exports = __webpack_public_path__ + "static/media/order.06b42eff.svg";